module.exports = __webpack_public_path__ + "img/spirt.14428f04.png";